import React from "react";
import PropTypes from 'prop-types';
import RichText from "../../Util/RichText";

const Message = ({body}) => (
    <div className='media-body'>
        <RichText content={body}/>
    </div>
);

Message.propTypes = {
    body: PropTypes.string.isRequired
};

export default Message;
